import SpecDetailContainer from "./SpecDetailContainer";
export default SpecDetailContainer;
